import { Grid, Switch } from '@mui/material';
import SoftBox from 'components/SoftBox';
import React, { useState } from 'react';
import { useAgencyInfo } from "context/agency";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import CopyToClipboard from "react-copy-to-clipboard";
import env from "config/env";
import SoftTypography from 'components/SoftTypography';
import FormField from "layouts/pages/account/components/FormField";
import { useUploadImage } from "hook/services";
function SocialApp({ handleImage, handleSubmit, loading}) {
  const customUrlDomain = env.ACCOUNT_LEVEL_URL
  const SERVER_IP = env.SERVER_IP;
  const [agency] = useAgencyInfo();
  const [domainupdate, setDomainupdate] = useState(false);
  const [DefaultImage, setDefaultImage] = useState(agency?.Customization?.default_image || true);
  const [custom_color, setcustom_color] = useState(agency?.Customization?.custom_color || false);
  const [copy, setcopy] = useState(false);
  const [default_image_switch, setdefault_image_switch] = useState(false);
  const url = agency?.domain
    ? `https://${agency.domain}/{{user.email}}/{{location.id}}/app/home?sessionKey={{user.sessionKey}}`
    : `${customUrlDomain}/{{user.email}}/{{location.id}}/app/home?sessionKey={{user.sessionKey}}`;
  const handlecopy = () => {
    setcopy(true);

    setTimeout(() => {
      setcopy(false);
    }, 2000);
  };
  const uploadImage = useUploadImage();
  const [whitelabel_logo, setwhitelabel_logo] = useState(agency?.Customization?.whitelabel_logo || "");
  const [chatapp_logo, setChatapp_logo] = useState(agency?.Customization?.chatapp_logo || "");
  const handleImageinner = async (e, type) => {
    const response = await uploadImage({
      file: e.target.files[0],
      desiredPath: `design/logo/image`,
    });
    if (type == "whitelabel_logo") {
      setwhitelabel_logo(response.response.data);
    } else if (type == "chatapp_logo") {
      setChatapp_logo(response.response.data);
    }
    handleImage(response.response.data, type)
  };
  return (
    <div>
      <SoftBox component="form" onSubmit={handleSubmit}>
        <Grid container spacing={3} rowSpacing={2} paddingX={3} style={{ paddingBottom: 0 }}>
          <Grid item xs={12}>
            <SoftTypography variant="h5">Your Favicon Logo</SoftTypography>
          </Grid>

          <Grid item xs={12} className='px-2'>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div className='custom-upload-pad'>
                {chatapp_logo ? (
                  <img
                    src={chatapp_logo}
                    alt="chatapp_logo"
                    width={100}
                    height={50}
                    style={{
                      width: "100%",
                      height: "100%"
                    }}
                  />
                ) :
                  <SoftButton className='img-center' variant="outlined" component="label" color="dark">
                    <div>
                      <svg width="100" height="30" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.38444 3.98444L4.99555 5.68667L4.58611 5.31056L6.66222 2.77778L8.74722 5.325L8.32889 5.69444L6.94 3.98556V8.33333H6.38444V3.98444ZM10.2778 9.44444H3.05556C1.67722 9.44444 0.555556 8.32333 0.555556 6.94444C0.555556 5.73444 1.41944 4.70111 2.61 4.48667L3.04278 4.40889L3.06667 3.97056C3.16944 2.055 4.75056 0.555556 6.66667 0.555556C8.58278 0.555556 10.1639 2.055 10.2656 3.97056L10.29 4.40889L10.7233 4.48667C11.9133 4.70111 12.7778 5.73444 12.7778 6.94444C12.7778 8.32333 11.6561 9.44444 10.2778 9.44444ZM10.8211 3.94C10.7033 1.745 8.89222 0 6.66667 0C4.44111 0 2.62944 1.745 2.51167 3.94C1.08389 4.19722 0 5.44333 0 6.94444C0 8.63167 1.36833 10 3.05556 10H10.2778C11.965 10 13.3333 8.63167 13.3333 6.94444C13.3333 5.44333 12.2494 4.19722 10.8211 3.94Z" fill="#757575" />
                      </svg>
                    </div>
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      name="chatapp_logo"
                      onChange={(e) => handleImageinner(e, "chatapp_logo")}
                    />
                  </SoftButton>
                }
              </div>

              {agency?.Customization?.chatapp_logo &&
                <div className='buttonupload' style={{ marginLeft: "10px", marginTop: "100px" }}>
                  <label >  <div>
                    <svg width="14" height="20" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.38444 3.98444L4.99555 5.68667L4.58611 5.31056L6.66222 2.77778L8.74722 5.325L8.32889 5.69444L6.94 3.98556V8.33333H6.38444V3.98444ZM10.2778 9.44444H3.05556C1.67722 9.44444 0.555556 8.32333 0.555556 6.94444C0.555556 5.73444 1.41944 4.70111 2.61 4.48667L3.04278 4.40889L3.06667 3.97056C3.16944 2.055 4.75056 0.555556 6.66667 0.555556C8.58278 0.555556 10.1639 2.055 10.2656 3.97056L10.29 4.40889L10.7233 4.48667C11.9133 4.70111 12.7778 5.73444 12.7778 6.94444C12.7778 8.32333 11.6561 9.44444 10.2778 9.44444ZM10.8211 3.94C10.7033 1.745 8.89222 0 6.66667 0C4.44111 0 2.62944 1.745 2.51167 3.94C1.08389 4.19722 0 5.44333 0 6.94444C0 8.63167 1.36833 10 3.05556 10H10.2778C11.965 10 13.3333 8.63167 13.3333 6.94444C13.3333 5.44333 12.2494 4.19722 10.8211 3.94Z" fill="#757575" />
                    </svg>
                  </div>
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      name="chatapp_logo"
                      onChange={(e) => handleImageinner(e, "chatapp_logo")}
                    />
                  </label>
                </div>}
            </div>
          </Grid>

          <Grid item xs={4} className='px-2'>
            <FormField
              label="Your AI meta title"
              placeholder="How can Your AI help you today?"
              name="chat_m_title"
              defaultValue={agency?.Customization?.chat_m_title}
            />
          </Grid>
          <Grid item xs={4} className='px-2'>
            <FormField
              label="Your AI meta description"
              placeholder="Add Meta Description"
              name="chat_m_description"
              defaultValue={agency?.Customization?.chat_m_description}
            />
          </Grid>
          <Grid item xs={4} className='px-2'>
            <FormField
              label="Your AI hero text"
              placeholder="How can Your AI help you today?"
              name="chatapp_text"
              defaultValue={agency?.Customization?.chatapp_text}
            />
          </Grid>
          {/* <Grid item xs={4} className='px-2'>
            <FormField
              label="Copy icon"
              placeholder="Copy"
              name="copyicon_text"
              defaultValue={agency?.Customization?.copyicon_text ?? 'Copy'}
            />
          </Grid>
          <Grid item xs={4} className='px-2'>
            <FormField
              label="Add to memory icon"
              placeholder="Add to memory"
              name="brainicon_text"
              defaultValue={agency?.Customization?.brainicon_text ?? 'Add to memory'}
            />
          </Grid>
          <Grid item xs={4} className='px-2'>
            <FormField
              label="Paperclip icon"
              placeholder="Upload File"
              name="uploadicone_text"
              defaultValue={agency?.Customization?.uploadicone_text ?? 'Upload files'}
            />
          </Grid> */}
          <Grid item xs={12} className='px-2' display="flex" justifyContent={"flex-end"}>
            <SoftButton className="bg-dark" color="dark" type="submit"
            disabled={loading} // Disable the button while loading
            style={{
              cursor: loading ? 'no-drop' : 'pointer', // Change cursor to 'not-allowed' (red circle) while loading
            }}
            >
              update
            </SoftButton>
          </Grid>
        </Grid>
      </SoftBox>
    </div>
  )
}

export default SocialApp 
